import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs';

export function useCarrierContractListFilter() {
  const [carriers, setCarriers] = useQueryState('carriers', parseAsArrayOf(parseAsString).withDefault([]));
  const [search, setSearch] = useQueryState('search', parseAsString.withDefault(''));

  return {
    setCarriers,
    setSearch,
    carriers,
    search,
  };
}
